import { cn } from '@/lib/utils';
import type { FlowMetrics, FlowSales } from '@/services/dynamicFlowsService';
import { buildKpis } from './metricsUtils';

export function MetricsKpis({ totals, sales }: { totals: FlowMetrics['totals'] | undefined; sales?: FlowSales }) {
  const kpis = buildKpis(totals, sales);
  return (
    <div className="grid grid-cols-[repeat(auto-fit,minmax(min(100%,190px),1fr))] gap-3.5">
      {kpis.map((kpi) => (
        <div
          key={kpi.key}
          className={cn(
            'flex flex-col gap-1.5 rounded-2xl border p-4',
            kpi.highlight ? 'border-[#BFD3FF] bg-[#EEF4FF] text-[#1E3A8A]' : 'border-[#D9E0EA] bg-white',
          )}
        >
          <span className={cn('text-[13px]', kpi.highlight ? 'text-[#1E3A8A]' : 'text-[#4B5563]')}>
            {kpi.label}
          </span>
          <span className={cn('text-[26px] font-bold', kpi.highlight ? 'text-[#1E3A8A]' : 'text-[#111827]')}>
            {kpi.value}
          </span>
          <span className={cn('text-xs', kpi.highlight ? 'text-[#1E3A8A]' : 'text-[#6B7280]')}>
            {kpi.hint}
          </span>
        </div>
      ))}
    </div>
  );
}
